import { getSafeUrl } from '@monorepo/shared';
import { useNavigate } from 'react-router-dom';
import { Button } from 'rsuite';
import { EnvConst, fcHost } from '../../config/const';

export const NoPermission = () => {
  const navigate = useNavigate();
  const logOutUrl = getSafeUrl(`${EnvConst.auth_host}/ssologout/`);
  const handleLogoff = () => {
    window.open(logOutUrl, '_self');
  };
  const goToHome = () => {
    navigate('/');
  };
  const goToSupport = () => {
    window.open(fcHost, '_blank');
  };
  return (
    <div className="no-permission-container">
      <div className="message-box">
        <div className="title">{'Sorry, you cannot view the page.'}</div>
        <div className="desc">
          <p>{'No permission to access this page'}</p>
          <p>
            {
              'Please use the navigation menu or click the buttons below to access the page.'
            }
          </p>
        </div>
        <div className="buttons-container">
          <Button
            appearance="primary"
            className="btn switch-user"
            onClick={handleLogoff}
          >
            {'Login with different user'}
          </Button>
          <Button
            appearance="primary"
            className="btn to-home"
            // onClick={goToHome}
            onClick={goToSupport}
          >
            {/* {'Go To Homepage'} */}
            {'Go To Support Page'}
          </Button>
        </div>
      </div>
    </div>
  );
};
